import { IContactFormValues } from 'components/ContactForm/withContactFormState';
import * as rp from 'request-promise';

export const sendContactEmail = (
  email: IContactFormValues & { to: string }
) => {
  
  const uri = (process.env.REACT_APP_FUNCTIONS_ENDPOINT || '') + '/contact';
  const options: rp.Options = {
    body: email,
    json: true,
    method: 'POST',
    uri
  };
  return rp(options);
};



// WEBPACK FOOTER //
// ./src/utils/sendContactEmail.ts